import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/store";
import * as types from "@/store/types";
import routes from './routers'
import LoginAboutToken from '@/host/getToken'
const loginAboutTokenFn = new LoginAboutToken();

Vue.use(VueRouter);
// 页面刷新时，重新赋值token
// loginAboutTokenFn.getToken();
if (window.sessionStorage.getItem('token')) {
    // store.commit(types.LOGIN, window.sessionStorage.getItem('token'));
}

const router = new VueRouter({
    mode: 'history',
    routes
});
router.beforeEach((to, from, next) => {
    sessionStorage.fromRouterpath = from.path;
    sessionStorage.toRouterpath = to.name;
    
    document.documentElement.scrollTop = document.body.scrollTop = 0;

    console.log(to.meta.requireAuth)
    next();
    // let token = sessionStorage.token;
    // console.log(token);
    // next();
    // if(token){
    //     next();
    // }else{
    //     next()
    // }
    
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js